//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
    }
  },
  props: {
    list: {
      type: Array,
      default: ()=>{
        return []
      }
    },
    // middle = true 时 list.length == 1 或者 ==2 时 前两个是居中，超出顺序排列
    // 默认全部顺序排列
    middle:{
      type: Boolean,
      default: false
    },
  },
}
